export default __webpack_public_path__ + "4242d2d76bd06fd8cdd72f339f464894.jpg";